import * as api from './api'
import { getLocalData, setLocalData } from '@/helper/localStorage'
import { REPAIR } from '@/constants/localStorage'
import { checkTtlDate } from '@/helper'
import { THREE_HOUR } from '@/constants/time'

export default {
  async loadData ({ commit }, { force = false } = {}) {
    const repairLocal = getLocalData(REPAIR)
    const isNeedUpdate = checkTtlDate({
      timeUpdate: (repairLocal?.updateDate || 0),
      ttlTime: THREE_HOUR
    })

    if (!force && repairLocal && !isNeedUpdate) {
      commit('setData', repairLocal.data)

      return { data: repairLocal.data }
    }

    const { data } = await api.loadData() || {}

    if (data?.code === 200) {
      commit('setData', data.data)

      setLocalData(REPAIR, {
        updateDate: Date.now(),
        data: data.data
      })

      return { data: data.data }
    }

    return { error: data.data }
  },
  async open ({ commit, state }, id) {
    const { data } = await api.open(id) || {}

    if (data?.code === 200) {
      const newData = state.data.map(item => {
        if (item.id === id) {
          item = {
            ...item,
            repairStatus: 'opened'
          }
        }

        return item
      })

      commit('setData', newData)

      setLocalData(REPAIR, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data.data }
  },
  async inRepair ({ commit, state }, id) {
    const { data } = await api.inRepair(id) || {}

    if (data?.code === 200) {
      const newData = state.data.map(item => {
        if (item.id === id) {
          item = {
            ...item,
            repairStatus: 'repairInRepair'
          }
        }

        return item
      })

      commit('setData', newData)

      setLocalData(REPAIR, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data.data }
  },
  async close ({ commit, state }, payload) {
    const { id, data: payloadData } = payload || {}
    const { data } = await api.close(id, payloadData) || {}

    if (data?.code === 200) {
      const newData = state.data.map(item => {
        if (item.id === id) {
          item = {
            ...item,
            repairStatus: 'closed'
          }
        }

        return item
      })

      commit('setData', newData)

      setLocalData(REPAIR, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data.data }
  },
  async cashOperation ({ state }, payload) {
    const { id, data: payloadData } = payload || {}

    const { data } = await api.cashOperation(id, payloadData) || {}

    if (data?.code === 200) {
      const newData = state.data
      newData.unshift(data.data)

      return { data: data.data }
    }

    return { error: data.data }
  },
  async create ({ commit, state }, payload) {
    const { data } = await api.create(payload) || {}

    if (data?.code === 200) {
      const newData = state.data
      newData.unshift(data.data)

      commit('setData', newData)

      setLocalData(REPAIR, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data.data }
  },
  async change ({ commit, state }, payload) {
    const { id, data: payloadData } = payload || {}
    const { data } = await api.change(id, payloadData) || {}

    if (data?.code === 200) {
      const newData = state.data.map(item => {
        if (item.id === id) {
          item = {
            ...item,
            ...payloadData
          }
        }

        return item
      })

      commit('setData', newData)

      setLocalData(REPAIR, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data.data }
  },
  async remove ({ commit, state }, payload) {
    const { data } = await api.remove(payload) || {}

    if (data?.code === 200) {
      const newData = state.data.filter(({id}) => id !== payload)

      commit('setData', newData)

      setLocalData(REPAIR, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data.data }
  }
}
